import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getSubsidyById } from '../../../../api/subsidy/queries/getSubsidyById';
import { ISubsidy } from '../../../../interfaces/Subsidy.interfaces';

interface IUseGetSubsidyByIdQueryParams {
  subsidyId: string;
}

export const useGetSubsidyByIdQuery = ({ subsidyId }: IUseGetSubsidyByIdQueryParams) => {
  return useQuery<ISubsidy, AxiosError>(['subsidy_by_id', subsidyId], () => getSubsidyById({ subsidyId }), {
    enabled: Boolean(subsidyId),
  });
};
